import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons/Icon';
export interface CbChatIconProps {
  color?: string;
  fontWeight?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export const CbChatIcon: FC<CbChatIconProps> = ({
  color = 'text.secondary',
  fontWeight = 'semibold',
  size = 'md'
}) => {
  const tokenSize = size === 'sm' ? ['16px', '20px'] : ['20px', '24px'];
  return <Flex alignItems="center" data-sentry-element="Flex" data-sentry-component="CbChatIcon" data-sentry-source-file="CbChatIcon.tsx">
      <ICON_BY_NAME.chaticon width={tokenSize} height={tokenSize} data-sentry-element="unknown" data-sentry-source-file="CbChatIcon.tsx" />
      <Text color={color} fontSize={size} fontWeight={fontWeight} data-sentry-element="Text" data-sentry-source-file="CbChatIcon.tsx">
        Chat
      </Text>
    </Flex>;
};